<template>
  <div>
    <el-dialog
      title="查看用户信息"
      append-to-body
      :visible.sync="openDialog"
      width="80%">
      <el-form ref="userInfoFormRef" label-width="100px" :model="userInfo">
        <el-row>
          <el-col :span="8">
            <el-form-item label="账号:" prop="username">
              {{userInfo.username}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户名字:" prop="name">
              {{userInfo.name}}
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="用户联系电话:">
              {{userInfo.phone}}
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="用户邮箱:">
              {{userInfo.email}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注:" prop="brief">
              {{userInfo.brief}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否是会员:" prop="vip">
              {{userInfo.vip | formatYESNo}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="积分:" prop="integral">
              {{userInfo.integral }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="头像:" prop="photo">
              <el-image
                style="width: 50px; height: 50px"
                :src="userInfo.photo"
                fit="contain"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">关闭窗口</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'userInfo',
  props: {
    btn: {
      type: String,
      default: '查看下单用户信息'
    }
  },
  data() {
    return {
      userInfo: {},
      openDialog: false
    }
  },
  methods: {
    cancel() {
      this.openDialog = false
      this.userInfo = {}
    },
    getUserInfo(row) {
      if (!row) {
        this.$message.info('暂无用户信息!')
        return
      }
      this.userInfo = JSON.parse(JSON.stringify(row))
      this.openDialog = true
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-input {
  width: 90%;
}
</style>
